import React from "react";
import { Button, StyledText } from "../../../../components/common";
import { BackIcon, CloseIcon } from "../../../../components/svgs";
import { useTheme } from "../../../../hooks";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import FeedbackIcon from "../images/feedbackIcon.png";

const ModalOverlay = styled.div`
  position: absolute;
  z-index: 100;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
`;

const ModalContent = styled.div`
  position: absolute;
  z-index: 100;
  width: 100%;
  bottom: 0;
  box-sizing: border-box;
  padding: 20px 20px;
  // height: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  margin-top: 70%;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 5px;
  margin-bottom: 5px;
`;

const CloseButton = styled.div`
  cursor: pointer;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  img {
    width: 80px;
  }
`;

const TakeSurveyModal = ({
  isOpen,
  onClose,
  interactionID,
  surveyCode,
  analytics,
}) => {
  const { themeContext, theme } = useTheme();
  const history = useHistory();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  if (!isOpen) return null;

  // const goToSurvey = () => {
  //   history.push(`/event_survey/offers-survey`, {
  //     interactionID,
  //     surveyCode,
  //   });
  // };

  const goToSurvey = () => {
    const url = `https://arcg.is/90PO91`;
    window.open(url, "_blank");
    localStorage.setItem(surveyCode, "true");
    analytics();
    onClose();
  };

  return (
    <>
      <ModalOverlay onClick={onClose} />
      <ModalContent>
        <div
          style={{
            width: 50,
            height: 8,
            backgroundColor: "#cbcbcb",
            borderRadius: 10,
          }}
          onClick={onClose}
        />
        <Header>
          <CloseButton onClick={onClose}>
            <CloseIcon />
          </CloseButton>
        </Header>

        <StyledText style={{ fontSize: 20 }}>Feedback Survey</StyledText>
        <IconContainer>
          <img src={FeedbackIcon} alt="feedback icon" />
        </IconContainer>
        <StyledText
          style={{
            textAlign: "center",
            fontFamily: "MTNRegular",
            paddingInline: 15,
          }}
        >
          Hey Pulser! We’re giving your digital hangout a fresh new vibe —
          starting with the name. Help us pick one that feels real, fun, and
          truly you. Your voice matters in shaping this space!
        </StyledText>
        <Button
          style={{
            backgroundColor: background,
            width: "80%",
            marginBottom: 16,
          }}
          onClick={goToSurvey}
        >
          <StyledText color="white">Take survey</StyledText>
        </Button>
        <Button
          style={{
            backgroundColor: "#fff",
            width: "80%",
            border: `1px solid ${background}`,
          }}
          onClick={onClose}
        >
          <StyledText color={background}>Not now</StyledText>
        </Button>
      </ModalContent>
    </>
  );
};

export default TakeSurveyModal;
